import { Component, input } from '@angular/core';
import type { EcmpAffiliateLogo } from '@core/navigation-store';
import { GenericLinkDirective } from '@core/jss-utils';

@Component({
  selector: 'wl-ecmp-header-image[ecmpHeader]',
  templateUrl: './ecmp-header-image.component.html',
  styleUrls: ['./ecmp-header-image.component.scss'],
  standalone: true,
  imports: [GenericLinkDirective],
})
export class EcmpHeaderImageComponent {
  readonly ecmpHeader = input.required<EcmpAffiliateLogo>();
}
